import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20gradient%20background%20with%20soft%20golden%20and%20deep%20shadow%20tones%2C%20film%20texture%20overlay%2C%20elegant%20theatrical%20atmosphere%2C%20curtain-like%20flowing%20shapes%2C%20warm%20amber%20and%20dark%20contrast%2C%20professional%20cinema%20aesthetic&width=1440&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="6080影视背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs md:text-sm font-medium text-primary-300 bg-primary-500/15 px-3 py-1.5 rounded-full mb-5 tracking-wide whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight">
              6080影视
              <span className="block text-primary-400 md:inline md:ml-2">
                · 电视剧全集免费高清在线观看
              </span>
            </h1>

            <p className="mt-3 text-sm md:text-base text-white/70 font-medium tracking-wide whitespace-nowrap">
              {heroData.slogan}
            </p>

            <div className="mt-6 space-y-2.5">
              <p className="text-sm md:text-base text-white/80 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
                {heroData.intro}
              </p>
              <p className="text-sm md:text-base text-white/75 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
                {heroData.intro2}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-2xl font-bold text-primary-400 font-heading whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="text-xs text-white/60 mt-0.5 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={heroData.cta1.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(heroData.cta1.href);
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-semibold text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg" />
                {heroData.cta1.text}
              </a>
              <a
                href={heroData.cta2.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(heroData.cta2.href);
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-white/30 hover:border-white/60 text-white font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg" />
                {heroData.cta2.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none shrink-0">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20Chinese%20television%20drama%20scenes%20with%20warm%20golden%20lighting%2C%20ancient%20and%20modern%20costumes%20blended%20artistically%2C%20dramatic%20cinematic%20composition%2C%20film%20grain%20texture%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20elegant%20theatrical%20poster%20style&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="6080影视热门剧集"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}